import React, { PureComponent } from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { HeaderBase, LogoAndAppTitle } from "altus-ui-components";

import { APP_NAME } from "app/app.constants";

class LoginHeader extends PureComponent {
  render() {
    return (
      <HeaderBase>
        <Grid container alignItems="center" spacing={2}>
          <LogoAndAppTitle title={APP_NAME} to={null} />
        </Grid>
      </HeaderBase>
    );
  }
}

export default compose()(LoginHeader);
